
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#ef5350","data-name":"vuesax/twotone/login"}},[_c('path',{attrs:{"d":"M19.051 27.85h-.163c-2.8 0-4.771-.529-6.19-1.665a7.412 7.412 0 01-2.493-5.423.938.938 0 011.867-.174 5.6 5.6 0 001.8 4.133c1.055.844 2.7 1.254 5.019 1.254h.162c2.594 0 4.292-.49 5.345-1.543s1.54-2.75 1.54-5.344v-8.151c0-2.594-.49-4.292-1.543-5.345s-2.75-1.542-5.344-1.542h-.163c-2.339 0-3.989.416-5.044 1.272S12.238 7.506 12.06 9.53a.938.938 0 11-1.869-.16c.429-4.976 3.111-7.195 8.697-7.195h.162c3.124 0 5.244.665 6.671 2.092s2.092 3.547 2.092 6.671v8.15c0 3.124-.665 5.244-2.092 6.671s-3.547 2.091-6.67 2.091z"}}),_c('g',{attrs:{"data-name":"Group 655","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M18.601 15.937h-16.1a.938.938 0 010-1.875h16.1a.938.938 0 010 1.875z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15.813 20.125a.937.937 0 01-.662-1.6L18.675 15l-3.524-3.525a.937.937 0 011.325-1.325l4.188 4.187a.938.938 0 010 1.326l-4.188 4.187a.935.935 0 01-.663.275z"}})])])])
          )
        }
      }
    